import React, { useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Formik, Form, Field } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../Appstore/store';
import { AddIpAddress, GetAllipAddress } from '../Features/AllowIpData';
import * as Yup from 'yup';
import { RootState } from '../Appstore/store';
import { toast } from 'sonner';

interface AddallowIPmodalProps {
    show: boolean;
    onHide: () => void;
}

interface AllowIP {
    ip: string;
    status: number;
}

const validationSchema = Yup.object({
    ip: Yup.string()
        .matches(
            /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/,
            'Invalid IP address'
        )
        .required('IP Address is required'),
    status: Yup.string().required('Status is required'),
});

const AddallowIPmodal: React.FC<AddallowIPmodalProps> = ({ show, onHide }) => {
    const dispatch = useDispatch<AppDispatch>();

    const { error }: any = useSelector((state: RootState) => state.allowIp);

    const initialValues = {
        ip: '',
        status: 'Active',
    };

    useEffect(() => {
        const defaultPage = 1;
        const defaultLimit = 10;
        dispatch(GetAllipAddress({ search: '', page: defaultPage, limit: defaultLimit }));
    }, [dispatch]);

    useEffect(() => {
        if (error) {
            toast.error(error || 'An error occurred while adding the IP address');
        }
    }, [error]);

    return (
        <>
            <Modal show={show} onHide={onHide} centered>
                <Modal.Header closeButton className="border-0">
                    <Modal.Title>Add IP Address</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={async (values, { resetForm, setSubmitting }) => {
                            const allowipData: AllowIP = {
                                ip: values.ip,
                                status: values.status === 'Active' ? 1 : 0,
                            };

                            try {
                                const response: any = await dispatch(AddIpAddress(allowipData));
                                dispatch(GetAllipAddress({ search: '', page: 1, limit: 10 }));
                                if (response.payload && response.payload.status === 'success') {
                                    toast.success(response.payload.message);
                                    resetForm();
                                    onHide();
                                    await dispatch(GetAllipAddress({ search: '', page: 1, limit: 10 }));
                                } else if (response.payload?.status === 'error') {
                                    const backendErrorMessage = response.payload.message || 'Invalid credentials';
                                    toast.error(backendErrorMessage);
                                }
                            } catch (err: any) {
                                const errorMessage = err.message || 'An unexpected error occurred';
                                toast.error(errorMessage);
                            } finally {
                                setSubmitting(false);
                            }
                        }}
                    >
                        {({ errors, touched, handleChange, values, isSubmitting }) => (
                            <Form>
                                <div className="form-group mb-3">
                                    <label htmlFor="ip">IP Address<span className="text-danger">*</span></label>
                                    <Field
                                        type="text"
                                        className={`form-control shadow-none ${touched.ip && errors.ip ? 'is-invalid' : ''}`}
                                        id="ip"
                                        name="ip"
                                        placeholder="Enter IP Address"
                                    />
                                    {touched.ip && errors.ip ? (
                                        <div className="invalid-feedback">{errors.ip}</div>
                                    ) : null}
                                </div>

                                <div className="form-group mb-3">
                                    <label>Status<span className="text-danger">*</span></label>
                                    <select
                                        name="status"
                                        className="form-select shadow-none"
                                        value={values.status}
                                        onChange={handleChange}
                                    >
                                        <option value="Active">Active</option>
                                        <option value="Deactive">Deactive</option>
                                    </select>
                                    {touched.status && errors.status && (
                                        <div className="text-danger">{errors.status}</div>
                                    )}
                                </div>

                                <Modal.Footer className="d-flex justify-content-center border-0">
                                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                <span className='ps-2'>Submitting...</span>
                                            </>
                                        ) : (
                                            "Submit"
                                        )}
                                    </Button>
                                    <Button style={{ width: 76.5 }} variant="secondary" onClick={onHide}>
                                        Close
                                    </Button>
                                </Modal.Footer>
                            </Form>
                        )}
                    </Formik>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddallowIPmodal;
